<template>
  <a-drawer
    :title="title"
    :width="960"
    :visible="visible"
    @close="onClose"
    :body-style="{ paddingBottom: '80px' }"
  >
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('视频评价.评价内容')">
              <a-input v-model="queryParam.discussContent" :maxLength="32"
                       :placeholder="$t('通用.输入.请输入')+$t('视频评价.评价内容')" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('视频评价.评价状态')">
              <a-select v-model="queryParam.discussState" allowClear style="width:100%"
                        :placeholder="$t('通用.输入.请选择')+$t('视频评价.评价状态')">
                <a-select-option value="1">{{ $t('视频评价.审核通过') }}</a-select-option>
                <a-select-option value="0">{{ $t('视频评价.审核未通过') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 数据展示 -->
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
    >
      <span slot="userInfo" slot-scope="text, record">
        {{ $t('视频评价.昵称') }}：{{ record.userNickName || '-' }} <br/>
        {{ $t('视频评价.手机号') }}：{{ record.userMobile || '-' }} <br/>
      </span>
      <span slot="discussUserInfo" slot-scope="text, record">
        {{ $t('视频评价.昵称') }}：{{ record.discussUserNickName || '-' }} <br/>
        {{ $t('视频评价.手机号') }}：{{ record.discussUserMobile || '-' }} <br/>
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="discussState" slot-scope="text">
        {{ text === 1 ? $t('视频评价.审核通过') : $t('视频评价.审核未通过') }}
      </span>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(record)" v-hasPermi="['video:video:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a>
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-drawer>
</template>

<script>
import { pageDiscuss, delDiscuss } from '@/api/discuss/discuss.js'
import {mapGetters} from 'vuex'
import moment from 'moment';
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'DiscussList',
  mixins: [tableMixin],
  data () {
    return {
      visible: false,
      title: '',
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        videoId: undefined,
        discussContent: undefined,
        discussState: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('视频评价.被评价用户'),
          dataIndex: 'userInfo',
          scopedSlots: { customRender: 'userInfo' },
          width: 180,
          align: 'center'
        },
        {
          title: this.$t('视频评价.评价用户'),
          dataIndex: 'discussUserInfo',
          scopedSlots: { customRender: 'discussUserInfo' },
          width: 180,
          align: 'center'
        },
        {
          title: this.$t('视频评价.评价内容'),
          dataIndex: 'discussContent',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('视频评价.评价状态'),
          dataIndex: 'discussState',
          scopedSlots: { customRender: 'discussState' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('视频评价.回复数量'),
          dataIndex: 'replyNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    moment,
    /** 打开评论列表弹窗（由视频列表页调用） */
    show (record) {
      this.title = this.$t('查看评论')
      this.queryParam = {
        videoId: record.id,
        discussContent: undefined,
        discussState: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.visible = true
      this.getList()
    },
    onClose () {
      this.visible = false
    },
    getTotal (total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询视频评价列表 */
    getList () {
      this.loading = true
      pageDiscuss(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        videoId: this.queryParam.videoId,
        discussContent: undefined,
        discussState: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delDiscuss(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('通用.文本.删除成功'),
                3
              )
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    }
  }
}
</script>
